import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { ReconstructedPrompt } from "../ChatDebugRecord";

/**
 * Reconstruct the exact Bedrock request that produced one assistant message.
 *
 * Reconstructed prompts are large, so callers gate the fetch with `enabled`
 * (e.g. only when the admin expands a turn) rather than loading every turn's
 * prompt up front.
 */
export function useChatMessagePrompt(
  chatId: string,
  messageSequenceNum: number,
  enabled: boolean,
) {
  const { adminService } = useDomainServices();

  return useQuery<ReconstructedPrompt, Error>({
    queryKey: ["adminChatPrompt", chatId, messageSequenceNum],
    queryFn: ({ signal }) =>
      adminService.getChatMessagePrompt(chatId, messageSequenceNum, {
        abortSignal: signal,
      }),
    enabled: enabled && !!chatId,
    staleTime: 30000,
  });
}
